import React, { FC } from "react";
import cn from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import { ReactComponent as ArrowLeftIcon } from "src/assets/icons/arrow-left-circle.svg";
import { PRINCIPLE_ITEMS } from "./constanst";
import { PrincipleItem } from "./PrincipleItem";

export const PrincipleSlider: FC = () => (
  <>
    {/* Mobile: grid як було раніше */}
    <div className="grid grid-cols-2 gap-x-5 gap-y-5 xl:hidden">
      {PRINCIPLE_ITEMS.map((item) => (
        <PrincipleItem key={item.id} {...item} />
      ))}
    </div>

    {/* Desktop (xl+): слайдер з 4 елементами */}
    <div className="hidden xl:flex items-center gap-5 w-full">
      <button
        type="button"
        aria-label="Попередній"
        className={cn(
          "principle-slider__prev shrink-0 transition-opacity hover:opacity-80 disabled:opacity-40"
        )}
      >
        <ArrowLeftIcon width={56} height={56} />
      </button>

      <Swiper
        className="w-full"
        modules={[Navigation]}
        navigation={{
          prevEl: ".principle-slider__prev",
          nextEl: ".principle-slider__next",
        }}
        slidesPerView={4}
        spaceBetween={20}
      >
        {PRINCIPLE_ITEMS.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="max-h-[193px] overflow-hidden">
              <PrincipleItem {...item} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <button
        type="button"
        aria-label="Наступний"
        className={cn(
          "principle-slider__next shrink-0 transition-opacity hover:opacity-80 disabled:opacity-40"
        )}
      >
        <ArrowLeftIcon width={56} height={56} className="rotate-180" />
      </button>
    </div>
  </>
);
